exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mt-overlay-1 img {\r\n    z-index: 5;\r\n}\r\n\r\n.mt-overlay-1 .mt-overlay {\r\n    z-index: 6;\r\n}\r\n\r\ndiv#location-modal div.modal-dialog {\r\n    width: 95%;\r\n    height: 95%;\r\n    margin: 0;\r\n    padding: 0;\r\n    display: block;\r\n    margin: auto;\r\n    margin-top: 50px;\r\n}\r\n\r\ndiv#location-modal div.modal-content {\r\n    height: 95%;\r\n    border-radius: 0;\r\n}\r\n\r\nspan.location-modal-link {\r\n    transition: linear 0.1s;\r\n}\r\n\r\nspan.location-modal-link:hover {\r\n    cursor: pointer;\r\n    transition: linear 0.1s;\r\n    color: #FC6119;\r\n}\r\n\r\ndiv.leaflet-popup-content {\r\n    text-align: center;\r\n    font-size: 10px !important;\r\n}\r\n\r\n.mt-element-overlay .mt-overlay-1 img {\r\n    height: 150px;\r\n    width: auto;\r\n    display: inline-block;\r\n}\r\n\r\n.mt-overlay {\r\n    height: 150px;\r\n}\r\n\r\n.portlet.light > .portlet-title > .caption > .caption-subject {\r\n    font-size: 18px;\r\n}\r\n\r\ntextarea{\r\n    max-width: 100%;\r\n}\r\n\r\n.tabbable-line > .nav-tabs > li > a {\r\n    padding: 6px 12px;\r\n    font-size: 18px !important;\r\n    font-weight: 600 !important;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/case/details/report/case-details-report.component.css
// module id = 978
// module chunks = 1